// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__LspIq","col":"styles_col__UPPC4"};